export default "__VITE_ASSET__yU$vT92___"